import { Icon, ospThemes } from "@ospweb/sdk-ui";

import React from "react";
import { cn } from "utils";
import NextImage from "../NextImage";
import { SourceMetadataType } from "./Source";

export default function SourceFooter({
  metaData,
  containerClassName,
  logoSize = 16,
  contentClassName,
}: {
  metaData?: SourceMetadataType;
  containerClassName?: string;
  logoSize?: number;
  contentClassName?: string;
}) {
  if (!metaData?.type) {
    return null;
  }

  const isTwitterSource = metaData.type === "tweet";
  return (
    <div className={cn("flex flex-row items-center gap-1", containerClassName)}>
      <NextImage
        alt="web_icon"
        width={logoSize}
        height={logoSize}
        className="rounded-full shrink-0"
        src={`${isTwitterSource ? metaData?.avatar : "/assets/images/globe_web_icon.png"}`}
      />

      <div
        className={cn(
          "flex-1 body_s text-content_tertiary truncate",
          contentClassName,
        )}
      >
        {isTwitterSource ? metaData?.author : metaData?.url}
      </div>
      {isTwitterSource && (
        <Icon
          name="twitter"
          size={12}
          color={ospThemes.colors.content_quaternary}
        />
      )}
    </div>
  );
}
